import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";

import { useNavigate } from "react-router-dom";
import ApiClient from "../ApiClient";
import { getRequestGlobal } from "../../../API/global";

const CardCinemaAi = ({ handlePrint, impoData }) => {
  const { getRequest, postRequest } = ApiClient();
  const [preData, setPredata] = useState([]);
  const [language, setLanguage] = useState({});
  const navigate = useNavigate();
  const [oldYearData, setOldYearData] = useState([]);
  const [showAddNewEntryCmot, setShowAddNewEntryCmot] = useState(false); // New state for activeTab === 2

  const [craftData, setCraftData] = useState([]);

  useEffect(() => {
    loadCraft();
    fetchData();
  }, []);

  const loadCraft = async () => {
    let data = {};
    const predata = await getRequest(`craft`, {});
    if (predata.status && predata.data.length) {
      for (const craft of predata.data) {
        data[craft.id] = craft.name;
      }
      setCraftData(data);
    }
  };
  const fetchData = async () => {
    try {
      const preData = await getRequest("cinemai");
      const data = preData.data;
      setPredata(data);
      const olddata = preData?.oldlistdata || [];
      console.log("Cinema Ai old Data", olddata);
      setOldYearData(olddata);
      // if (data && data.length <= 1) setShowAddNewEntryCmot(true);
      // console.log('Data:', data);
    } catch (error) {
      console.error("Fetch error:", error);
    }
  };

  useEffect(() => {
    getRequestGlobal("language_list", {})
      .then((data) => {
        // console.log(data, "language data ott");
        setLanguage(data.data);
      })
      .catch((error) => {
        console.error("Fetch error:", error);
      });
  }, []);

  const handleEditClick = (id) => {
    navigate(`/cinemai-hackathon/${id}`);
  };

  const handleViewClick = (id) => {
    navigate(`/cinemai-hackathon/view/${id}`);
  };

  const handleDelete = async (id) => {
    const confirmDelete = window.confirm("Are you sure you want to delete?");
    if (confirmDelete) {
      try {
        const data = await postRequest(`cinemai/delete/${id}`);
        if (data.status) {
          window.location.reload();
        }
        // setPredata(preData.filter((item) => item.id !== id));
      } catch (error) {
        console.error("Delete error:", error);
      }
    }
  };

  // const addNewEntryCmot = () => {
  //     if (showAddNewEntryCmot) {
  //         navigate("/cmot"); // Assuming '/Cmot' is the correct route
  //     } else {
  //         alert("You have reached the maximum limit.");
  //     }
  // }

  const [cinemaClosed, setCinemaClosed] = useState();

  useEffect(() => {
    if (impoData?.cmot) {
      const CinemaAI = impoData.cinema.close;
      console.log(CinemaAI);
      setCinemaClosed(CinemaAI);
    }
  }, [impoData]);

  return (
    <>
      {preData.length === 0 ? (
        <div className="text-center">
          <p className="no-content">
            {" "}
            <h4>
              You haven't added any entries yet. To get started, simply click on{" "}
              <Button
                sx={{ color: "inherit" }}
                // variant="contained"
                onClick={() => navigate("/cinemai-hackathon")}
                style={{ backgroundColor: "#1c5768", color: "#fff" }}
              >
                Add New Entry
              </Button>
            </h4>
          </p>
        </div>
      ) : (
        <div className="card-container">
          <>
            {preData.map((item) => (
              <div className="card_con" key={item.id}>
                <h1 className="title mb-4">{item.name}</h1>

                <ul className="listView">
                  <>
                    <li>
                      <h5>Film Title</h5>{" "}
                      <h6>{item.payload.film_title}</h6>
                    </li>
                  </>
                  <>
                    <li>
                      <h5>Genre/Theme</h5>{" "}
                      <h6>{item.payload.genre_theme}</h6>
                    </li>
                  </>
                  <>
                    <li>
                      <h5>Duration</h5>{" "}
                      <h6>{item.payload.duration}</h6>
                    </li>
                  </>
                  {item.submission_date_and_time ?
                    <>
                      <li>
                        <h5>Submission Date & Time</h5>
                        <h6>{item.submission_date_and_time}</h6>
                      </li>
                    </> : <></>
                  }

                </ul>
                <div className="button_con">
                  {item.step >= 6 ? (
                    <Button
                      style={{ color: "#fff" }}
                      onClick={() => handleViewClick(item.id)}
                    >
                      View
                    </Button>
                  ) : (
                    <>
                      {cinemaClosed === 1 ? (
                        <>
                          <Button
                            variant="contained"
                            onClick={() => handleEditClick(item.id)}
                          >
                            <EditIcon />
                            Edit
                          </Button>
                          <Button
                            className="del_btn"
                            variant="contained"
                            onClick={() => handleDelete(item.id)}
                            startIcon={<DeleteIcon sx={{ color: "#f67474" }} />}
                          >
                            Delete
                          </Button>
                        </>
                      ) : (
                        <></>
                      )}
                    </>
                  )}
                </div>
              </div>
            ))}
          </>
        </div>
      )}

    </>
  );
};

export default CardCinemaAi;
